import React from 'react';
import {
    Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@mui/material';
import type { CertRow, CertStatus } from '../../api/certApi';
import RevokeButton from './RevokeButton';

const statusColor: Record<CertStatus, 'default' | 'info' | 'success' | 'error' | 'warning'> = {
    pending:  'warning',
    approved: 'info',
    denied:   'error',
    active:   'success',
    revoked:  'default',
    expired:  'default',
};

interface Props {
    certs: CertRow[];
    token: string;
    onChanged: () => void;
}

const CertList: React.FC<Props> = ({ certs, token, onChanged }) => (
    <TableContainer component={Paper}>
        <Table size='small'>
            <TableHead>
                <TableRow>
                    <TableCell>CN</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Issued</TableCell>
                    <TableCell>Expires</TableCell>
                    <TableCell>Requested by</TableCell>
                    <TableCell>Fingerprint</TableCell>
                    <TableCell>Actions</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {certs.map(c => (
                    <TableRow key={c.serial} hover>
                        <TableCell>{c.cn}</TableCell>
                        <TableCell><Chip size='small' label={c.status} color={statusColor[c.status]} /></TableCell>
                        <TableCell>{c.issued_at?.slice(0, 10) ?? '—'}</TableCell>
                        <TableCell>{c.expires_at?.slice(0, 10) ?? '—'}</TableCell>
                        <TableCell>{c.requested_by_email ?? c.requested_by}</TableCell>
                        <TableCell sx={{ fontFamily: 'monospace', fontSize: '0.7rem' }}>
                            {c.fingerprint_sha256?.slice(0, 24) ?? '—'}
                        </TableCell>
                        <TableCell>
                            {c.status === 'active' && (
                                <RevokeButton token={token} serial={c.serial} cn={c.cn} onRevoked={onChanged} />
                            )}
                        </TableCell>
                    </TableRow>
                ))}
                {certs.length === 0 && (
                    <TableRow>
                        <TableCell colSpan={7} align='center' sx={{ color: 'text.secondary' }}>
                            No certificates yet
                        </TableCell>
                    </TableRow>
                )}
            </TableBody>
        </Table>
    </TableContainer>
);

export default CertList;
